// Какже хотелось это на реакте всё делать...
import { Calendar } from 'vanilla-calendar-pro'
import gsap from "gsap";

import Swiper from 'swiper';
import { Pagination, Navigation} from 'swiper';

import axios from 'axios';
window.axios = axios;

import {num_word, mobileCheck} from "./functions";

export default class search {
    localeDateOptions = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        timezone: 'UTC'
    };

    localeDateOptionsLong = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timezone: 'UTC'
    };

    endpoint = "/search";

    modeLink = false;
    link = "";
    

    constructor(options) {
        this.elements = {};
        this.elements.block = document.querySelector(options.selector);

        // Переключение между ссылкой и списком объектов
        this.modeLink = options.modeLink ? true : false;

        if(!this.elements.block) {
            return;
        }

        // Калькулятор гостей
        this.guestsCount = 2;
        this.guestsChildCount = 0;

        if(localStorage.getItem("guests.parent")) {
            this.guestsCount = +localStorage.getItem("guests.parent");
        }

        if(localStorage.getItem("guests.child")) {
            this.guestsChildCount  = +localStorage.getItem("guests.child");
        } 

        // Кнопки и инпуты формы поиска
        this.elements.in = this.elements.block.querySelector('.js-search-in');
        this.elements.out = this.elements.block.querySelector('.js-search-out');
        this.elements.btn = this.elements.block.querySelector('.js-search-btn');
        this.elements.list = this.elements.block.querySelector('.js-search-list');
        this.elements.error = this.elements.block.querySelector('.js-search-error');
        this.elements.loading = this.elements.block.querySelector('.js-search-loading');
        this.elements.dates = this.elements.block.querySelector('.js-search-dates');
        this.elements.guests = this.elements.block.querySelector('.js-search-guests');
        this.elements.guestsContainer = document.querySelector('.js-search-guestsContainer');
        this.elements.guestsBtn = this.elements.guestsContainer.querySelector('.js-search-guestsBtn');
        this.elements.guestsValue = this.elements.block.querySelector('.js-search-value');

        // Создание календаря
        // - Абсолютное место для календаря
        this.elements.calendarContainer = document.createElement("div");
        this.elements.calendarContainer.classList.add("hns-calendar");
        this.elements.calendarContainer.classList.add("hns-calendar_border");

        let title = document.createElement("div");
        title.classList.add("hns-calendar__title");
        title.innerHTML = "Для бронирования номера выберите даты заезда и выезда и нажмите кнопку Найти.";

        this.elements.result = document.createElement("div");
        this.elements.result.classList.add("hns-calendar__result");
        this.elements.result.innerHTML = "";

        let btn = document.createElement("div");
        btn.classList.add("hns-calendar__btn");
        btn.innerHTML = "Применить";
        this.elements.chooseDatasBtn = btn;

        this.elements.calendarElement = document.createElement("div");
        // - Сборка 
        this.elements.calendarContainer.append( title ); 
        this.elements.calendarContainer.append( this.elements.calendarElement);
        this.elements.calendarContainer.append( this.elements.result);
        this.elements.calendarContainer.append( btn ); 

        document.body.append( this.elements.calendarContainer);

        // - Инициализация календаря

        // Получаем данные из локального хранилища
        this.dates = getDates();
        

        let calendarOptions = {
            locale: 'ru-RU',
            selectionDatesMode: 'multiple-ranged',
            disableDatesPast: true,
            disableDatesGaps: true,
            selectedDates: [this.dates.join(" ")],
            themeAttrDetect: 'html[data-theme]',
            onClickDate: (self, event) => {
                this.dates = self.context.selectedDates;
                this.dateChange();
            },
            onInit:(self) => {
                if(this.modeLink) {
                    this.dateChange();
                } else {
                    this.dateVisibleUpdate();
                }
            }
        }
        this.calendar = new Calendar( this.elements.calendarElement, calendarOptions);
        this.calendar.init();


        // События
        this.events = {};

        this.events.onInit = () => {
            if(typeof options.onInit === "function") {
                options.onInit(this);
            }
        }   

        this.events.onShowCalendar = () => {
            if(typeof options.onShowCalendar === "function") {
                options.onShowCalendar(this);
            }
            this.showCalendar();
        }  

        this.events.onChooseDates = () => {
            if(typeof options.onChooseDates === "function") {
                options.onChooseDates(this);
            }
            this.chooseDates();
        } 

        this.events.onDateChange = () => {
            if(typeof options.onDateChange === "function") {
                options.onDateChange(this);
            }
            this.dateChange();
        } 

        // Fire onInit
        this.events.onInit();

        // Fire onShowCalendar
        for(let elem of [this.elements.in, this.elements.out]) {
            elem.addEventListener('click',  () => this.events.onShowCalendar())
        }

        // Fire onChooseDates
        this.elements.chooseDatasBtn.addEventListener('click',  () => this.chooseDates());

        // Actions  
        this.elements.guests.addEventListener('click', () => this.showGuests());
        this.elements.guestsBtn.addEventListener('click', () => this.hideGuests());

        if(this.elements.btn) {
            this.elements.btn.addEventListener('click',() => {
            
                if(this.modeLink) {
                    window.location.href = this.link;
                } else {
                    this.hideGuests();
                    this.hideCalendar();
                    this.updateResults();
                }
            });
        }

        this.updateGuests();

        const blockParent = this.elements.guestsContainer.querySelector('.js-counter');
        const btnMinesParent = blockParent.querySelector('[data-mines]');
        const btnPlusParent = blockParent.querySelector('[data-plus]');
        const valueParentBlock = blockParent.querySelector('[data-value]');
        valueParentBlock.innerHTML = this.guestsCount;

        const blockChild  = document.querySelector('.js-counter-child');
        const btnMinesCildren = blockChild.querySelector('[data-mines]');
        const btnPlusCildren = blockChild.querySelector('[data-plus]');
        const valueChildBlock = blockChild.querySelector('[data-value]');
        valueChildBlock.innerHTML = this.guestsChildCount;

        btnPlusParent.addEventListener('click', () => {
            this.guestsCount++;
            valueParentBlock.innerHTML = this.guestsCount;
            localStorage.setItem("guests.parent", this.guestsCount);
            this.updateGuests();
            this.updateResults();
        });
        
        btnMinesParent.addEventListener('click', () => {
            if(this.guestsCount == 1) {
                return;
            } 
            this.guestsCount--;
            localStorage.setItem("guests.parent", this.guestsCount);
            valueParentBlock.innerHTML = this.guestsCount;
            this.updateGuests();
            this.updateResults();

        });

        btnPlusCildren.addEventListener('click', () => {
            this.guestsChildCount++;
            valueChildBlock.innerHTML = this.guestsChildCount;
            localStorage.setItem("guests.child", this.guestsChildCount);
            this.updateGuests();
            this.updateResults();
        });
        
        btnMinesCildren.addEventListener('click', () => {
            if(this.guestsChildCount == 0) {
                return;
            } 
            this.guestsChildCount--;
            localStorage.setItem("guests.child", this.guestsChildCount);
            valueChildBlock.innerHTML = this.guestsChildCount;
            this.updateGuests();
            this.updateResults();
        });

        this.initSwipers()
    }   

    updateGuests() { 
        this.elements.guestsValue.innerHTML = `${this.guestsCount} ${num_word(this.guestsCount,  ["взрослый", "взрослых", "взрослых"])}`;
        if(this.guestsChildCount) {
            this.elements.guestsValue.innerHTML += `, ${this.guestsChildCount} ${num_word(this.guestsChildCount,  ["ребёнок", "ребёнка", "детей"])}`;
        } else {
            this.elements.guestsValue.innerHTML += ", без детей"
        }
    }

    showCalendar() {
        this.scrollPosition = window.scrollY;
        if(mobileCheck()) {
            this.elements.calendarContainer.classList.add("hns-calendar_view-mobile"); 
            document.body.classList.add('hns-overview-mode');
        } else {
            let y = this.elements.dates.offsetTop;
            let x = this.elements.dates.offsetLeft;
            let width = this.elements.dates.getBoundingClientRect().width;
            let style = this.elements.calendarContainer.style;
            style.top = y + "px";
            style.left = x + "px";
            style.width = width + "px";
            this.elements.calendarContainer.classList.add("hns-calendar_view");
        }
    }

    hideCalendar() {
        if(mobileCheck()) {
            if(this.elements.calendarContainer.classList.contains("hns-calendar_view-mobile")) {
                this.elements.calendarContainer.classList.remove("hns-calendar_view-mobile");
                document.body.classList.remove('hns-overview-mode');
                window.scroll(0, this.scrollPosition);
            }
        } else {
            this.elements.calendarContainer.classList.remove("hns-calendar_view");
        }
    }

    showGuests() {
        /*
        if(this.mobileCheck()) {
            this.elements.guestsContainer.classList.add("hns-guests_view-mobile"); 
            document.body.classList.add('hns-overview-mode');
        } else {
            */
            let y = this.elements.guests.offsetTop;
            let x = this.elements.guests.offsetLeft;
            let width = this.elements.guests.getBoundingClientRect().width;
            let style = this.elements.guestsContainer.style;
            style.top = y + "px";
            style.left = x + "px";
            style.width = width + "px";
            this.elements.guestsContainer.classList.add("hns-guests_view");
        //}
    }

    hideGuests() {
        /*if(this.mobileCheck()) {
            this.elements.guestsContainer.classList.remove("hns-guests_view-mobile");
            document.body.classList.remove('hns-overview-mode');
            window.scroll(0, this.scrollPosition);
        } else {*/
            this.elements.guestsContainer.classList.remove("hns-guests_view");
        //}
    }
    

    chooseDates() {
        this.hideCalendar();
    }

    dateChange() {
        this.dateVisibleUpdate();
        this.updateResults();
    }

    dateVisibleUpdate() {
        this.elements.result.innerHTML = ""; 

        if(!this.dates[0] || typeof this.dates[0] === "undefined") {
            this.elements.in.querySelector("[data-value]").innerHTML = 'не выбрано';
            return;
        } 
        
        if(!this.dates[1] || typeof this.dates[1] === "undefined") {
            this.elements.out.querySelector("[data-value]").innerHTML = 'не выбрано';
            return;
        }

        if(this.dates.length != 2) {
            return;
        }

        let diffDay = this.dateDiffinDays(new Date(this.dates[0]), new Date(this.dates[1]));

        localStorage.setItem("dates.0", this.dates[0]);
        localStorage.setItem("dates.1", this.dates[1]);

        // Форматирование дат
        const inDate = new Date(this.dates[0]).toLocaleString("ru", this.localeDateOptions);
        const outDate = new Date(this.dates[1]).toLocaleString("ru", this.localeDateOptions);

        const inDateLong = new Date(this.dates[0]).toLocaleString("ru", this.localeDateOptionsLong);
        const outDateLong = new Date(this.dates[1]).toLocaleString("ru", this.localeDateOptionsLong);

        this.elements.result.innerHTML = `${inDateLong} - ${outDateLong}, ${diffDay} ${num_word(diffDay, ["ночь", "ночи", "ночей"])}`;

        // отображение дат
        this.elements.in.querySelector("[data-value]").innerHTML = inDate;
        this.elements.out.querySelector("[data-value]").innerHTML = outDate;

        // пересчёт гостей
        this.guestsCountAll = this.guestsCount + this.guestsChildCount;

        localStorage.setItem("guests.parent", this.guestsCount ? this.guestsCount : 2 );
        localStorage.setItem("guests.child", this.guestsChildCount ? this.guestsChildCount : 0);
    }

    updateResults() {

        this.hideError();

        // Прячем контент
        if(this.elements.list && false) {
            gsap.fromTo(
                this.elements.list, 
                {
                    opacity:1,
                    //height: "auto"
                }, 
                {
                    opacity:0, 
                    duration: 0.4,
                    //height: "0px"
                }
            );
        }
        
        // Показываем загрузку
        if(!this.dates[0] || !this.dates[1]) {
            this.showError("Возникла ошибка. Пожалуйста, перезагрузите страницу и повторите запрос.");
            return;
        }

        this.guestsCountAll = this.guestsChildCount + this.guestsCount;

        axios.post(this.endpoint, {
            arrival: this.dates[0],
            departure: this.dates[1],
            guests: this.guestsCountAll,
            countOnly: this.modeLink, // для вариантов
        })
        .then((response) => {
            
            if(response.data.error) {
                this.showError("Возникла ошибка. Пожалуйста, перезагрузите страницу и повторите запрос.");
                return;
            }

            if(this.modeLink) {
                /** 
                 * Получаем количество вариантов, пишем в кнопке.
                 */
                if(response.data.count) {
                    this.elements.btn.innerHTML =  response.data.count + " " + num_word(response.data.count, ["вариант", "варианта", "вариантов"]) ;
                }

                if(response.data.count === 0) {
                    this.elements.btn.innerHTML = "Нет вариантов";
                }
                
                this.link = "/objects?arrival=" + this.dates[0] + "&departure=" + this.dates[1] + "&guests=" + this.guestsCountAll;

                return;
            } else {
                /** 
                 * Получаем html со списком, инициализируем слайдеры
                 */

                if(response.data.status == "error") {
                    console.log("%c "  + response.data.message, "color:d00;");
                    this.elements.list.innerHTML = "";
                    this.elements.error.innerHTML = response.data.message;
                    this.showError(response.data.message);
                    return;
                }
                
                this.elements.list.innerHTML = response.data.html;

                // ИНИЦИАЛИЗАЦИЯ СЛАЙДЕРОВ
                this.initSwipers();

                gsap.fromTo(
                    this.elements.list, 
                    {
                        opacity:0,
                        //height: "0px"
                    }, 
                    {
                        opacity:1, 
                        duration: 0.4,
                        //height: "auto",
                    }
                );
                
                return;
            }


            /** 
             * Далее прошлый вариант, тут просто
             */
            let innerHTML = '';
            for(let item of response.data) {
                innerHTML += `<a class="hns-hlist__item" target="_blank" href="${item.link}">
                    <div class="hns-hlist__item-img">
                        <img src="${item.images[0]}" width="" height="">
                    </div>
                    <div class="hns-hlist__item-name">${item.name}</div>
                    <div class="hns-hlist__item-price">${item.priceFormat} в сутки</div>
                </a>`;
            }

            this.elements.list.innerHTML = innerHTML;

            gsap.fromTo(
                this.elements.list, 
                {
                    opacity:0,
                    //height: "0px"
                }, 
                {
                    opacity:1, 
                    duration: 0.4,
                    //height: "auto",
                }
            );
        });
    }

    initSwipers() {
    
        if(!this.elements.list) {
            return;
        }

        for(let swiperElem of this.elements.list.querySelectorAll(".swiper")) {
            // Слайдер
            new Swiper(swiperElem, {
                modules: [Pagination, Navigation],
                slidesPerView: "auto",
                pagination: {
                    el: ".js-swiper-pagination",
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            }); 
        }
    }

    showError(message) {
        gsap.fromTo(
            this.elements.error, 
            {
                opacity:0,
                height: "0px",
            }, 
            {
                opacity: 1, 
                height: "auto",
                onStart: () => {
                    this.elements.error.innerHTML = message;
                },
                onComplete: () =>{
                    this.elements.error.innerHTML = message;
                }
            }
        );
       
    }

    hideError() {
        gsap.fromTo(
            this.elements.error, 
            {
                opacity:1,
                height: "auto"
            }, 
            {
                opacity:0, 
                height: "0px",
                onComplete: ()=> {
                     this.elements.error.innerHTML = "";
                }
            }
        );

    }

    dateDiffinDays(d1, d2) {
        var t2 = d2.getTime();
        var t1 = d1.getTime();
 
        return Math.floor((t2-t1)/(24*3600*1000));
    }
}

export function getDates() {
    let dates = [];

    if(localStorage.getItem("dates.0")) {
        dates[0] = localStorage.getItem("dates.0")
    } else { 
        let date = new Date();
        dates[0] = date.toISOString().split('T')[0];
    }
    if(localStorage.getItem("dates.1")) {
        dates[1] = localStorage.getItem("dates.1")
    } else {
        let date = new Date();
        date.setTime(Date.parse(dates[0]));
        date.setDate(date.getDate() + 1);
        dates[1] = date.toISOString().split('T')[0];
    }

    let date = new Date(dates[0]);
    if(date < new Date()) {
        let date = new Date();
        dates[0] = date.toISOString().split('T')[0];
        let date2 = new Date();
        date2.setTime(Date.parse(dates[0]));
        date2.setDate(date.getDate() + 1);
        dates[1] = date2.toISOString().split('T')[0];
    }

    return dates;
}

export function getAllGuest() {
    let guestsCount = 2;
    let guestsChildCount = 0;

    if(localStorage.getItem("guests.parent")) {
        guestsCount = +localStorage.getItem("guests.parent");
    }

    if(localStorage.getItem("guests.child")) {
        guestsChildCount  = +localStorage.getItem("guests.child");
    } 

    return  guestsCount + guestsChildCount;
}